import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';

import {Store} from "@/enums/Store";

import {LocationInterface, PlaceholderLocationInterface} from "@/types/Location";
import {PlaceholderLocation} from "@/util/Location";

@Module({
  namespaced: true
})
export default class Location extends VuexModule {
  location = new PlaceholderLocation();
  locationCode?: string = undefined;

  @Mutation
  SET_SELECTED_LOCATION(location?: LocationInterface) {
    if(!location) {
      this.location = new PlaceholderLocation();
      return;
    }
    this.location = location as LocationInterface
  }

  @Mutation
  SET_SELECTED_LOCATION_CODE(locationCode?: string) {
    this.locationCode = locationCode
  }

  @Mutation
  CLEAR_LOCATION() {
    this.locationCode = undefined;
    this.location = new PlaceholderLocation();
  }

  @Action
  setSelectedLocation(locationId?: string) {
    const {commit, rootState} = this.context;
    const selectedEvent = rootState[Store.EVENT].selectedEvent;
    if (selectedEvent) {
      const locations = selectedEvent.locations;

      if (!Array.isArray(locations)) {
        commit('SET_SELECTED_LOCATION', locations);
        return;
      }

      if (locations.length == 1) {
        commit('SET_SELECTED_LOCATION', locations[0]);
        return;
      }

      const location = (locations as LocationInterface[]).find((location: LocationInterface) => {
        return location.id == locationId;
      });

      commit('SET_SELECTED_LOCATION', location);
    }
  }
}
